import 'core-js/stable';
import smoothscroll from 'smoothscroll-polyfill';

smoothscroll.polyfill();
